import { OverrideFunc } from '../../../../model/Override'

export const MuiModal: OverrideFunc<'MuiModal'> = _theme => ({
  styleOverrides: {
    root: {
      border: '0px !important',
    },
  },
})
